/**
 * formatDriverName
 *
 * Takes a raw driver name from Firestore/RTDB and formats it as
 * "[FirstName] Anna" — e.g. "Badulla B" → "Badulla Anna".
 *
 * Rules:
 *  1. Strip any leading "Anna"/"Captain" prefix (idempotent).
 *  2. Take only the first word of the remaining name.
 *  3. Append " Anna".
 *  4. Falls back to "Anna" when name is missing/empty.
 */
export const formatDriverName = (raw) => {
  const cleaned = String(raw || '')
    .trim()
    .replace(/^(Anna|Captain)\s+/i, '')
    .trim();
  if (!cleaned) return 'Anna';
  const firstName = cleaned.split(/\s+/)[0];
  return `${firstName} Anna`;
};
